import { render, staticRenderFns } from "./TireTypePicker.vue?vue&type=template&id=a3b051e0&"
import script from "./TireTypePicker.controller.js?vue&type=script&lang=js&"
export * from "./TireTypePicker.controller.js?vue&type=script&lang=js&"
import style0 from "./TireTypePicker.styles.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports